import { type Permissions, getPermissions } from '@/shared/lib/permissions';
import { useAuthStore } from '@/features/auth/store/auth-store';

/**
 * Returns RBAC permissions for the current user.
 *
 * Usage:
 *   const { canEdit, canAdmin } = usePermissions();
 *   if (!canEdit) return null;
 */
export function usePermissions(): Permissions {
  const role = useAuthStore((s) => s.user?.role);
  return getPermissions(role ?? null);
}
